export default "__VITE_ASSET__C6hDgKbI__"